import { Button } from '@material-ui/core';
import React from 'react';
import { Modal, Row } from 'react-bootstrap';
import './styles.scss';

interface Props {
  onHide: () => void;
  show: boolean;
  onConfirmClick: () => void;
  message?: string;
}

const DeleteModal: React.FC<Props> = (props: Props) => {
  const { onHide, onConfirmClick } = props;

  return (
    <Modal {...props} className="modal-confirm" centered>
      <p className="title-modal">
        {props.message ? props.message : ''}
      </p>
      <Row noGutters className="container-buttons">
        <Button className="primary-button outline" onClick={onHide}>
          Não
        </Button>
        <Button className="primary-button" onClick={onConfirmClick}>
          Sim
        </Button>
      </Row>
    </Modal>
  );
};

export default DeleteModal;
